import axiosInstance from "../config/axios.config";
export const getReceptionistOutPatientListApi = (params) => {
  return axiosInstance.get(
    `appointments/op-admissions/list/?${params}`);
};
